var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,6 L20,6 L20,18 L4,18 L4,6 Z",
    stroke: "#FF8C42",
    strokeWidth: 2,
    fill: "#FF8C42",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10 L16,10",
    stroke: "#FF8C42",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,14 L16,14",
    stroke: "#FF8C42",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,18 L12,18",
    stroke: "#FF8C42",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.c6ab2bd3f4fa485a971d4614f76d5912.svg";
export { ForwardRef as ReactComponent };